// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { color, createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface CategoryItemSharedStyles {
    container?: GridContainerProps;
    categoryItem?: GridItemProps;
    innerContainer?: InjectableCss;
    categoryContainer?: InjectableCss;
    categoryHeader?: InjectableCss;
    categoryImageLink?: LinkPresentationProps;
    categoryImage?: LazyImageProps;
    subCategoryNameLink?: LinkPresentationProps;
    viewMoreLinkItem?: InjectableCss;
    viewMoreLink?: LinkPresentationProps;
}

const categoryItemSharedStyles: CategoryItemSharedStyles = {
    container: {
        gap: 22,
    },
    categoryItem: {
        width: [12, 6, 4, 4, 3],
        css: css`
            padding-bottom: 30px;
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-radius: 4px;
            border: 1px solid ${color("common.border")};
            width: 100%;
            height: 100%;
            ${xScreen("lte", "xs")} {
                height: auto;
            }
        `,
    },
    categoryContainer: {
        css: css`
            padding: 18px;
        `,
    },
    categoryHeader: {
        css: css`
            display: flex;
            align-items: center;
            gap: 12px;
            &.has-subcategories {
                border-bottom: 1px solid ${color("common.border")};
                padding-bottom: 12px;
                margin-bottom: 12px;
            }
        `,
    },
    categoryImageLink: {
        css: css`
            width: 108px;
            height: 108px;
        `,
    },
    categoryImage: {
        css: css`
            width: 108px;
            height: 108px;
            img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
                border-radius: 4px;
            }
        `,
    },
    subCategoryNameLink: {
        color: "text.main",
        typographyProps: {
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 19px;
                word-wrap: break-word;
            `,
        },
    },
    viewMoreLinkItem: {
        css: css`
            width: 100%;
            padding: 8px 16px;
            border-radius: 0 0 4px 4px;
            background: ${color("common.ui2")};
            display: flex;
        `,
    },
    viewMoreLink: {
        ...createLinkIconStyles(CaretRight, {
            typographyProps: {
                size: 12,
                weight: "bold",
                css: css`
                    letter-spacing: 0;
                    line-height: 15px;
                `,
            },
            icon: {
                iconProps: {
                    size: 10,
                },
            },
        }),
    },
};

export default categoryItemSharedStyles;
